import { Injector } from '@angular/core';

export class AppInjector {
  private static injector: Injector | null = null;

  static set(injector: Injector) {
    AppInjector.injector = injector;
  }

  static get(): Injector {
    if (!AppInjector.injector) {
      throw new Error('AppInjector has not been set yet');
    }
    return AppInjector.injector;
  }
}

